export function isTruthy<T>(value: T | null | undefined | false): value is T {
  return !!value;
}

export function isDefined<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined;
}
